var map = {
	"./restaurant1.jpg": 3013,
	"./restaurant10.jpg": 7871,
	"./restaurant11.jpg": 2019,
	"./restaurant12.jpg": 7605,
	"./restaurant13.jpg": 3268,
	"./restaurant14.jpg": 8108,
	"./restaurant15.jpg": 8921,
	"./restaurant16.jpg": 1162,
	"./restaurant17.jpg": 2052,
	"./restaurant18.jpg": 5109,
	"./restaurant19.jpg": 3035,
	"./restaurant2.jpg": 9951,
	"./restaurant20.jpg": 214,
	"./restaurant3.jpg": 5156,
	"./restaurant4.jpg": 8209,
	"./restaurant5.jpg": 2692,
	"./restaurant6.jpg": 6446,
	"./restaurant7.jpg": 4990,
	"./restaurant8.jpg": 6864,
	"./restaurant9.jpg": 5494
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9846;